// @mui material components
import {
  Snackbar,
  Alert,
  Card,
  Icon,
  // Tooltip,
  CircularProgress,
  Backdrop,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
  Container,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import CompanyNotification from "app/company_notification";
import AppConfig from "appConfig";
import successIcon from "assets/images/icons/custom/check.png";

function SalesGig() {
  const pageTitle = `Sales Team`;
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  function emptyCache() {
    if ("caches" in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
  }

  function versionRefresh() {
    emptyCache();
    window.location.reload();
  }

  function appVersionCheck(newVersion) {
    // Handle App Update
    const currentVersion = localStorage.getItem(AppConfig.app_version_store);
    let shouldUpdate = false;
    if (currentVersion !== newVersion) {
      shouldUpdate = true;
    }
    localStorage.setItem(AppConfig.app_version_store, newVersion);

    if (shouldUpdate) {
      if (
        window.confirm(
          "A new version is available. App will automatically refresh to get the latest update."
        ) === true
      ) {
        versionRefresh();
      } else {
        versionRefresh();
      }
    }
  }

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  const [gig, setGig] = useState(null);
  const [openHustleCampaignDialog, setOpenHustleCampaignDialog] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [joined, setJoined] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/hustle/gigs/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          console.log(result);
          if (result.data.status === "success") {
            setGig(result.data.data.rental);

            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("hustle")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setErrMsg(result.data.data.message);
            setSeverity("error");
            setOpen(true);
          }

          appVersionCheck(result.data.version);
        })
        .catch(() => {
          setShowLoading(false);
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setSeverity("error");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function join() {
    setShowLoading(true);

    const json = {
      reference: `${ref}`,
    };

    await axios
      .post("agents/hustle/gigs/join.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          // setSeverity("success");
          // setErrMsg(result.data.data.message);
          // setOpen(true);

          setJoined(true);
          setErrMsg(result.data.data.message);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      {joined ? (
        <Dialog open fullWidth maxWidth="xs">
          <DialogContent>
            <MDBox mt={3} align="center" mb={3}>
              <MDBox>
                <img src={successIcon} alt="warning" width={72} />
              </MDBox>
              <MDBox mt={1}>
                <MDTypography variant="h6" fontWeight="regular">
                  You&apos;ve joined the team!
                </MDTypography>
              </MDBox>
              <MDBox mt={2}>
                <MDTypography variant="h6" fontWeight="light">
                  {errorMsg}
                </MDTypography>
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              mr={3}
              onClick={() => {
                navigate("/gigs");
              }}
              color="primary"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                close
              </Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}
      {selectedCampaign ? (
        <Dialog open={openHustleCampaignDialog} fullWidth maxWidth="sm">
          <DialogContent>
            <Container align="left">
              <MDTypography align="left">
                <MDBox mt={1}>
                  <MDTypography variant="h6" fontWeight="light">
                    <b>Campaign</b>
                    <br />
                    {selectedCampaign.campaign.title}
                  </MDTypography>
                  {/* <Divider />
                  <MDTypography variant="h6" fontWeight="medium">
                    Products
                  </MDTypography>
                  {selectedCampaign.campaign.products.map((product) =>
                    product.status ? (
                      <MDBox mt={1} align="left">
                        <MDBox display="flex" justifyContent="space-between" alignItems="left">
                          <MDTypography variant="h6" fontWeight="light">
                            {product.title}
                          </MDTypography>
                          <MDTypography variant="h6" fontWeight="medium" align="right">
                            N{product.formatted_price}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    ) : (
                      <> </>
                    )
                  )} */}
                  <Divider />
                  <MDTypography variant="h6" fontWeight="medium">
                    Your Commission(s)
                  </MDTypography>
                  {selectedCampaign.campaign.commissions.length <= 0 ? (
                    <MDBox mt={2} align="left">
                      <MDTypography variant="h6" fontWeight="light">
                        No sales commissions available for campaign.
                      </MDTypography>
                    </MDBox>
                  ) : (
                    <MDBox>
                      {selectedCampaign.campaign.commissions.map((commission) => (
                        <MDBox mt={1} align="left">
                          <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDTypography variant="h6" fontWeight="light">
                              {commission.product}&nbsp;&nbsp;
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light">
                              <strong>
                                {commission.is_commission_percentage ? (
                                  <span>
                                    {(commission.commission * 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                    %
                                  </span>
                                ) : (
                                  <span>
                                    N
                                    {(commission.commission / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </span>
                                )}
                              </strong>
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      ))}
                    </MDBox>
                  )}

                  {selectedCampaign.campaign.incentives.sales.length <= 0 ? (
                    // <MDBox mt={2} align="left">
                    //   <MDTypography variant="h6" fontWeight="light" fontSize="medium">
                    //     No sales incentives available for campaign.
                    //   </MDTypography>
                    // </MDBox>
                    <> </>
                  ) : (
                    <>
                      {" "}
                      <Divider />
                      <MDTypography variant="h6" fontWeight="medium">
                        Your Sales Incentives
                      </MDTypography>
                      <MDBox>
                        {selectedCampaign.campaign.incentives.sales.map((incentive) => (
                          <MDBox mt={1} align="left">
                            <MDBox
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <MDTypography variant="h6" fontWeight="light" fontSize="medium">
                                {incentive.title} ({incentive.product}) <br />
                                <small>
                                  {incentive.sales} sales in {incentive.time_interval} days
                                </small>
                              </MDTypography>
                              <MDTypography
                                variant="h6"
                                fontWeight="light"
                                fontSize="medium"
                                align="right"
                              >
                                {incentive.incentive_type === "DATA" ? (
                                  <strong>{incentive.reward}</strong>
                                ) : (
                                  <strong>
                                    {incentive.is_reward_commission_percentage ? (
                                      <span>
                                        {(incentive.reward * 100).toLocaleString("en", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                        %
                                      </span>
                                    ) : (
                                      <span>
                                        N
                                        {(incentive.reward / 100).toLocaleString("en", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </span>
                                    )}
                                  </strong>
                                )}
                                <br />
                                <small>{incentive.incentive_type}</small>
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        ))}
                      </MDBox>
                    </>
                  )}
                  <Divider />
                  <MDTypography variant="h6" fontWeight="medium">
                    About Campaign
                  </MDTypography>
                  <MDBox mt={2} align="left">
                    <MDTypography variant="caption" fontWeight="light" fontSize={14}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            selectedCampaign.campaign.description.length > 0
                              ? selectedCampaign.campaign.description
                              : gig.account.title,
                        }}
                      />
                    </MDTypography>
                  </MDBox>
                  {/* <Divider />
                  <MDTypography variant="h6" fontWeight="medium">
                    Marketing Material
                  </MDTypography>
                  {selectedCampaign.campaign.branded_materials.length <= 0 ? (
                    <MDBox mt={2} align="left">
                      <MDTypography variant="h6" fontWeight="light">
                        No materials provided for campaign.
                      </MDTypography>
                    </MDBox>
                  ) : (
                    <MDBox>
                      {selectedCampaign.campaign.branded_materials.map((material) => (
                        <MDBox mt={1} align="left">
                          <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDTypography variant="h6" fontWeight="light">
                              {material.title}&nbsp;&nbsp;
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light">
                              {material.document_type !== "LINK" ? (
                                <a href={material.material} target="_blank" rel="noreferrer">
                                  <Icon sx={{ fontWeight: "bold" }}>download</Icon>
                                </a>
                              ) : (
                                <a href={material.content} target="_blank" rel="noreferrer">
                                  <Icon sx={{ fontWeight: "bold" }}>send</Icon>
                                </a>
                              )}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      ))}
                    </MDBox>
                  )} */}
                </MDBox>
              </MDTypography>
            </Container>
          </DialogContent>
          <DialogActions>
            <MDButton
              mr={3}
              onClick={() => {
                setOpenHustleCampaignDialog(false);
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                close
              </Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}
      <MDBox pb={3}>
        <MDBox>
          {gig === null ? (
            <Card sx={{ width: "100%", marginTop: "35px" }}>
              <MDBox pt={3} pb={2} px={2}>
                <MDBox
                  component="ul"
                  display="flex"
                  flexDirection="column"
                  p={0}
                  m={0}
                  sx={{ listStyle: "none" }}
                >
                  <MDTypography variant="h6" fontWeight="light">
                    Loading...
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          ) : (
            <MDBox mt={5}>
              <MDBox mb={3}>
                <Card sx={{ width: "100%" }}>
                  <MDBox p={2}>
                    <ListItem>
                      <ListItemIcon>
                        <img
                          src={`${AppConfig.api_media_url}${gig.account.logo}`}
                          // alt={product.name}
                          alt="<->"
                          width="48px"
                        />
                      </ListItemIcon>
                      <ListItemText
                        sx={{ mr: 2 }}
                        primary={
                          <MDTypography variant="h6" fontWeight="bold">
                            {gig.account.title}
                          </MDTypography>
                        }
                        secondary="Sales team"
                      />
                      <MDBox>
                        <MDBox mt={0} align="center">
                          <MDButton
                            variant="contained"
                            iconOnly
                            circular
                            color="primary"
                            onClick={() => {
                              join();
                            }}
                          >
                            <Icon>login</Icon>
                          </MDButton>
                          <MDTypography mt={1} variant="h6" fontWeight="regular" fontSize={12}>
                            JOIN
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    </ListItem>
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox
                mt={5}
                component="ul"
                display="flex"
                flexDirection="column"
                p={0}
                sx={{ listStyle: "none" }}
              >
                <Card sx={{ width: "100%" }}>
                  <MDBox p={2}>
                    <MDTypography variant="h6" fontWeight="bold">
                      Required Training
                    </MDTypography>
                  </MDBox>
                  {gig.courses.length > 0 ? (
                    <>
                      {" "}
                      {gig.courses.map((course) => (
                        <MDBox mb={3}>
                          <MDBox p={2}>
                            <ListItem sx={{ py: 1, px: 0 }}>
                              <ListItemIcon>
                                <MDBox align="right">
                                  <MDButton variant="outlined" iconOnly circular color="primary">
                                    <Icon>school</Icon>
                                  </MDButton>
                                </MDBox>
                              </ListItemIcon>
                              <ListItemText
                                sx={{ mr: 2 }}
                                primary={
                                  <MDTypography variant="h6" fontWeight="regular">
                                    {course.title}
                                  </MDTypography>
                                }
                                secondary={
                                  <MDTypography variant="caption" fontWeight="light">
                                    REQUIRED
                                  </MDTypography>
                                }
                              />
                            </ListItem>
                          </MDBox>
                        </MDBox>
                      ))}
                    </>
                  ) : (
                    <MDBox mb={3} px={2}>
                      <MDTypography variant="h6" fontWeight="light">
                        No training required.
                      </MDTypography>
                    </MDBox>
                  )}
                </Card>
              </MDBox>
              <MDBox
                mt={3}
                component="ul"
                display="flex"
                flexDirection="column"
                p={0}
                sx={{ listStyle: "none" }}
              >
                <Card sx={{ width: "100%" }}>
                  <MDBox p={2}>
                    <MDTypography variant="h6" fontWeight="bold">
                      Available Campaigns
                    </MDTypography>
                  </MDBox>
                  {gig.campaigns.map((record) => (
                    <MDBox
                      mb={0}
                      onClick={() => {
                        setSelectedCampaign(record);
                        setOpenHustleCampaignDialog(true);
                      }}
                    >
                      <MDBox px={2}>
                        <ListItem key={record.campaign.reference} sx={{ py: 1, px: 0 }}>
                          <ListItemText
                            sx={{ mr: 2 }}
                            primary={
                              <MDTypography variant="h6" fontWeight="light">
                                {record.campaign.title}
                              </MDTypography>
                            }
                            // secondary={
                            //   <MDTypography variant="caption" fontWeight="light">
                            //     <div
                            //       dangerouslySetInnerHTML={{
                            //         __html:
                            //           record.campaign.description.length > 0
                            //             ? record.campaign.description
                            //             : gig.account.title,
                            //       }}
                            //     />
                            //   </MDTypography>
                            // }
                          />
                          <MDBox align="right" sx={{ verticalAlign: "top", textAlign: "right" }}>
                            <MDButton
                              variant="outlined"
                              size="small"
                              iconOnly
                              circular
                              onClick={() => {
                                setSelectedCampaign(record);
                                setOpenHustleCampaignDialog(true);
                              }}
                              color="primary"
                            >
                              <Icon>visibility</Icon>
                            </MDButton>
                          </MDBox>
                        </ListItem>
                      </MDBox>
                      <MDBox mt={1} mb={1}>
                        <Divider />
                      </MDBox>
                    </MDBox>
                  ))}
                </Card>
              </MDBox>
            </MDBox>
          )}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SalesGig;
